import { configure } from "nprogress";
import request from "../request.js";
import axios from "axios";

// 请求头签名相关开始
// var X_API_Timestamp = Date.now();
// var X_API_Nonce =  Math.floor(Math.random() * 100) + 1;
// // var X_API_Signature = ""
// axios.defaults.headers["X-API-Timestamp"] =X_API_Timestamp;
// axios.defaults.headers["X-API-Nonce"] = X_API_Nonce;
// // axios.defaults.headers["X-API-Signature"] = "请求签名";
//
// export function XSignature() {
//   X_API_Timestamp = Date.now();
//   X_API_Nonce =  Math.floor(Math.random() * 100) + 1;
// }


// 请求头签名相关结束

//普通登录
// export function login(data) {
//   // console.log(typeof(data))
//   let ret = "";
//   for (let it in data) {
//     ret += encodeURIComponent(it) + "=" + encodeURIComponent(data[it]) + "&";
//   }
//   ret = ret.substring(0, ret.lastIndexOf("&"));
//   console.log(ret)
//   return request({
//      // url: "/v1/xoc/user/login",
//     url: "/api/v1/login/access-token",
//     method: "post",
//     data: ret,
//   });
// }

//普通登录
export function login(data) {
  return request({
    url: "/api/v1/login",
    headers: { "content-type": "application/json" },
    method: "post",
    data: data,
  });
}



//验证码
export function random_image(data) {
  return request({
    url: "/api/v1/random_image",
    headers: { "content-type": "application/json"},
    method: "post",
    data: data,
  });
}

// axios.defaults.headers["X-API-Signature"] = "请求签名";
// 签名计算
// var X_API_Timestamp = Date.now();
// var X_API_Nonce =  Math.floor(Math.random() * 100) + 1;
// axios.defaults.headers["X-API-Timestamp"] =X_API_Timestamp;
// axios.defaults.headers["X-API-Nonce"] = X_API_Nonce;


